import { CalendarDays, MapPin, RefreshCw, Ruler, UtensilsCrossed } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const steps = [
  {
    icon: MapPin,
    num: "01",
    title: "Escolher o ponto de partida",
    text: "Mapeie onde você está hoje e foque só no essencial — sem tentar mudar tudo de uma vez.",
  },
  {
    icon: CalendarDays,
    num: "02",
    title: "Montar o cardápio semanal",
    text: "Um jeito simples de planejar a semana inteira em minutos, com comida de verdade.",
  },
  {
    icon: UtensilsCrossed,
    num: "03",
    title: "A primeira semana na prática",
    text: "Coloque o plano em ação sem sofrimento, mesmo na rotina mais corrida.",
  },
  {
    icon: Ruler,
    num: "04",
    title: "Medir o que importa",
    text: "Aprenda a ler os sinais do corpo que vão muito além da balança.",
  },
  {
    icon: RefreshCw,
    num: "05",
    title: "Ajustar sem recomeçar",
    text: "Errou? Ajuste e siga. Constância duradoura sem o ciclo de recomeços.",
  },
];

export default function Method() {
  return (
    <section id="metodo" data-testid="method-section" className="py-24 sm:py-32">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow>O que muda quando existe método</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-4 font-serif text-3xl font-semibold leading-tight tracking-tight text-ink sm:text-4xl">
              Do zero ao equilíbrio em{" "}
              <span className="italic text-terracotta">5 passos</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-14">
          {steps.map((step, i) => (
            <Reveal key={step.num} delay={i * 0.06}>
              <div
                data-testid={`method-step-${i + 1}`}
                className="group relative flex items-start gap-6 border-b border-linen py-8 transition-colors sm:gap-10 sm:py-10"
              >
                <span className="pointer-events-none absolute -top-2 right-0 select-none font-serif text-7xl font-bold text-sage/15 transition-colors duration-500 group-hover:text-terracotta/25 sm:text-8xl">
                  {step.num}
                </span>
                <span className="mt-1 flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-forest text-cream transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-110">
                  <step.icon size={20} strokeWidth={2} />
                </span>
                <div>
                  <p className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta">
                    Passo {step.num}
                  </p>
                  <h3 className="mt-1.5 font-serif text-2xl font-medium text-ink">{step.title}</h3>
                  <p className="mt-2 max-w-xl text-sm leading-relaxed text-moss sm:text-base">
                    {step.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
